
import { MultiApp } from '@/config/context';
import { BaseUser } from './base-user';
import DjiUser from './dji';
import EuUser from './eu';
import InternalUser from './internal';
import ProUser from './pro';
import SgpUser from './sgp';
import WoaUser from './woa';


const userImplements: Record<MultiApp, any> = {
  [MultiApp.WOA]: WoaUser,
  [MultiApp.Internal]: InternalUser,
  [MultiApp.Pro]: ProUser,
  [MultiApp.Sgp]: SgpUser,
  [MultiApp.Eu]: EuUser,
  [MultiApp.Dji]: DjiUser,
};

export const userImplement: BaseUser<any> = new userImplements[process.env.APP_VERSION as MultiApp];
